exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\r\n  font-size: 1.7em;\r\n}\r\np{\r\n  text-align: center;\r\n  color: #3b6397;\r\n  font-family: \"Montserrat\";\r\n  font-weight: 500;\r\n}\r\n.main-button {\r\n  width: 100%;\r\n  height: 62px;\r\n  margin-top: 10px;\r\n}\r\napp-message-modal {\r\n  float: left;\r\n  padding: 24px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/uriel/Documents/newspaperReporteador/src/app/components/message-dialog/message-dialog.component.css
// module id = ../../../../../src/app/components/message-dialog/message-dialog.component.css
// module chunks = main